import { bindRequestLogic } from './utils'
import ServiceCenterAdminType from '../actionTypes/serviceCenterAdmin'
import { serviceCenterAdminAPI, systemConfigAPI } from '../api'

const getServiceCenterAdmins = bindRequestLogic({
  clientFunc: serviceCenterAdminAPI.getServiceCenterAdmins,
  type: ServiceCenterAdminType.GET_SERVICE_CENTER_ADMINS_REQUEST,
  successType: ServiceCenterAdminType.GET_SERVICE_CENTER_ADMINS_SUCCESS,
  failType: ServiceCenterAdminType.GET_SERVICE_CENTER_ADMINS_FAILED,
  isQueryParam: true
})

const addServiceCenterAdmin = bindRequestLogic({
  clientFunc: serviceCenterAdminAPI.addServiceCenterAdmin,
  type: ServiceCenterAdminType.ADD_SERVICE_CENTER_ADMIN_REQUEST,
  successType: ServiceCenterAdminType.ADD_SERVICE_CENTER_ADMIN_SUCCESS,
  failType: ServiceCenterAdminType.ADD_SERVICE_CENTER_ADMIN_FAILED
})

const getServiceCenterAdminDetail = bindRequestLogic({
  clientFunc: serviceCenterAdminAPI.getServiceCenterAdminDetail,
  type: ServiceCenterAdminType.GET_SERVICE_CENTER_ADMIN_DETAIL_REQUEST,
  successType: ServiceCenterAdminType.GET_SERVICE_CENTER_ADMIN_DETAIL_SUCCESS,
  failType: ServiceCenterAdminType.GET_SERVICE_CENTER_ADMIN_DETAIL_FAILED
})

const getServiceCenterAdminPortalRole = bindRequestLogic({
  clientFunc: serviceCenterAdminAPI.getServiceCenterAdminPortalRole,
  type: ServiceCenterAdminType.GET_SERVICE_CENTER_ADMIN_PORTAL_ROLE_REQUEST,
  successType:
    ServiceCenterAdminType.GET_SERVICE_CENTER_ADMIN_PORTAL_ROLE_SUCCESS,
  failType: ServiceCenterAdminType.GET_SERVICE_CENTER_ADMIN_PORTAL_ROLE_FAILED
})

const deleteServiceCenterAdmin = bindRequestLogic({
  clientFunc: serviceCenterAdminAPI.deleteServiceCenterAdmin,
  type: ServiceCenterAdminType.DELETE_SERVICE_CENTER_ADMIN_REQUEST,
  successType: ServiceCenterAdminType.DELETE_SERVICE_CENTER_ADMIN_SUCCESS,
  failType: ServiceCenterAdminType.DELETE_SERVICE_CENTER_ADMIN_FAILED
})

const resendInvitationServiceCenterAdmin = bindRequestLogic({
  clientFunc: serviceCenterAdminAPI.resendInvitation,
  type: ServiceCenterAdminType.RESEND_INVITATION_SERVICE_CENTER_REQUEST,
  successType: ServiceCenterAdminType.RESEND_INVITATION_SERVICE_CENTER_SUCCESS,
  failType: ServiceCenterAdminType.RESEND_INVITATION_SERVICE_CENTER_FAILED
})

const getCompanyRoleConfigurationById = bindRequestLogic({
  clientFunc: systemConfigAPI.getCompanyRoleConfigurationById,
  type: ServiceCenterAdminType.GET_COMPANY_ROLE_CONFIGURATION_BY_COMPANY_ID_REQUEST,
  successType:
    ServiceCenterAdminType.GET_COMPANY_ROLE_CONFIGURATION_BY_COMPANY_ID_SUCCESS,
  failType:
    ServiceCenterAdminType.GET_COMPANY_ROLE_CONFIGURATION_BY_COMPANY_ID_FAILED
})

const updateServiceCenterAdminRole = bindRequestLogic({
  clientFunc: serviceCenterAdminAPI.updateServiceCenterAdminRole,
  type: ServiceCenterAdminType.UPDATE_SERVICE_CENTER_ADMIN_ROLE_REQUEST,
  successType: ServiceCenterAdminType.UPDATE_SERVICE_CENTER_ADMIN_ROLE_SUCCESS,
  failType: ServiceCenterAdminType.UPDATE_SERVICE_CENTER_ADMIN_ROLE_FAILED
})

export default [
  getServiceCenterAdmins,
  addServiceCenterAdmin,
  getServiceCenterAdminDetail,
  deleteServiceCenterAdmin,
  getCompanyRoleConfigurationById,
  getServiceCenterAdminPortalRole,
  resendInvitationServiceCenterAdmin,
  updateServiceCenterAdminRole
]
